import { render, staticRenderFns } from "./DraggableChess.vue?vue&type=template&id=2e412d47&scoped=true&"
import script from "./DraggableChess.vue?vue&type=script&lang=js&"
export * from "./DraggableChess.vue?vue&type=script&lang=js&"
import style0 from "./DraggableChess.vue?vue&type=style&index=0&id=2e412d47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e412d47",
  null
  
)

export default component.exports